import { gql } from 'apollo-angular';
import { DocumentNode } from 'graphql';

const CREATE_USER: DocumentNode = gql`
mutation registerUSer ($input:ExternalUserContractInput!, $lang:String!){

registerUser(user: $input, lang:$lang){

isFederated
}
}
`;


const GET_STORE_CONFIG: DocumentNode = gql`
  query getStoreInfo($input: UUID!) {
    getStoreInfo(storeID: $input) {
      dateFormat
      storeLogo
      callingCode
      termsAndConditions
      storePhone
      storeEmail
      storeName
      permissionsDefaults {
        id
        action
        permissionId
        description
        isRequired
        flowsId
      }
      authProviders {
        authProviderId
        name
        displayName
        iconPath
        isEnabled
        styleValue
      }
      stateCountries{
        stateCountryId
        name
      }
      cities{
         cityId
         name
         stateCountryId
      }
    }
  }
`;


const UPDATE_USER: DocumentNode = gql`
mutation registerUSer ($input:ExternalUserContractInput!){

registerUser(user:$input)
}
`;

const DELETE_USER: DocumentNode = gql`
mutation deleteUser($filter:Int!){
  deleteUser(id:$filter)
}
`;

const DOWNLOAD_USER: DocumentNode = gql`
mutation {
  downLoadUsers
}

`;

const GET_FORM_BYMODULEID: DocumentNode = gql`
query GetFormByModuleId($moduleId: Int!, $storeId:UUID!,  $lang: String!) {
  fieldsByModuleId(moduleId: $moduleId, storeId: $storeId, lang: $lang) {
    contractName
    creationDate
    formId
    formName
    isActive
    updateDate
    userCreation
    userUpdate
    fields {
      fieldDescription
      fieldId
      fieldName
      fieldType
      formId
      isActive
      isByCountry
      isMandatory
      isVisible
      validations {
        countryId
        errorMessage
        fieldId
        isActive
        type
        validationId
        value
      }
    }
  }
}
`;
export { UPDATE_USER, CREATE_USER, DELETE_USER, DOWNLOAD_USER, GET_STORE_CONFIG, GET_FORM_BYMODULEID };
